import styled from 'styled-components';
import { Typography, Row as RowAntd, Input, Button, Form } from 'antd';
import colors from '../../../../../styles/colors';

const { Text } = Typography;
const { TextArea } = Input;

export const StyledText = styled(Text)`
  color: ${colors.greyText};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const Title = styled(Text)`
  color: ${colors.greyText};
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
`;

export const Row = styled(RowAntd)`
  justify-content: center;
  margin-bottom: 14px;
`;

export const StyledTextArea = styled(TextArea)`
  .ant-input: {
    background: red;
    resize: none;
  }
`;

export const StyledButton = styled(Button)`
  width: 116px;
  height: 40px;
  color: ${colors.branco};
  border-radius: 0;
  background: ${colors.verde} !important;
  border: none;
  outline: none;
  font-weight: bold;
  margin: 0 5px;

  &:hover {
    background: ${colors.verde};
    color: ${colors.branco};
    transform: scale(1.05);
  }
  &:focus {
    background: ${colors.verde};
    color: ${colors.branco};
  }
`;

export const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 0px; !important
  }
  
  .ant-form-item-control {
    align-items: center;
  }
`;
